var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoResult = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 95.981,
    viewBox: "0 0 96 95.981",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_result",
    "data-name": "No result",
    transform: "translate(-0.002 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4510",
    "data-name": "Path 4510",
    d: "M330.7,339.193l23.753,23.734a6.005,6.005,0,0,0,8.492-8.493L339.193,330.7a39.655,39.655,0,0,1-8.493,8.493",
    transform: "translate(-268.701 -268.701)",
    fill: "#047BC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4511",
    "data-name": "Path 4511",
    d: "M38.994,12a27,27,0,1,1-27,27,27,27,0,0,1,27-27m0,65.99A38.994,38.994,0,1,0,0,38.994,38.994,38.994,0,0,0,38.994,77.989",
    transform: "translate(0.002 0.002)",
    fill: "#888",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4512",
    "data-name": "Path 4512",
    d: "M155.876,131.31a3.074,3.074,0,0,0-4.347-4.347l-10.1,10.114-10.114-10.1a3.074,3.074,0,0,0-4.347,4.347l10.114,10.1-10.1,10.114a3.074,3.074,0,0,0,4.347,4.347l10.1-10.114,10.114,10.1a3.074,3.074,0,0,0,4.347-4.347l-10.114-10.1Z",
    transform: "translate(-102.43 -102.43)",
    fill: "#1a1a1a"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-result.e14f040d903a0a07af8ff5a4b82e091b.svg";